/* Assignment Action Types */
export const ADD_ASSIGNMENT_ID = "ADD_ASSIGNMENT_ID";
export const ADD_ASSIGNMENT_QUESTIONS = "ADD_ASSIGNMENT_QUESTIONS";
export const ADD_ASSIGNMENT_DESCRIPTIONS = "ADD_ASSIGNMENT_DESCRIPTIONS";
export const ADD_ASSIGNMENT_WEIGHTS = "ADD_ASSIGNMENT_WEIGHTS";
export const ADD_ASSIGNMENT_TOTAL_WEIGHT = "ADD_ASSIGNMENT_TOTAL_WEIGHT";
export const SET_ASSIGNMENT_GRADED = "SET_ASSIGNMENT_GRADED";
export const RESET_ASSIGNMENT = "RESET_ASSIGNMENT";